module.exports = __webpack_public_path__ + "static/media/iv_share_mail.209a0e1d.svg";